
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover/[citySlug]/top-events",
      function () {
        return require("private-next-pages/discover/[citySlug]/top-events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discover/[citySlug]/top-events"])
      });
    }
  